<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 sm10 md8>
          <v-card>
            <v-card-title class="py-0">
              <v-btn small href="/clients" @click.stop.prevent="goTo('/clients')" icon>
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <h3 class="text-center">Create Client</h3>
            </v-card-title>
            <v-card-text>
              <form @submit.prevent="submit">
                <v-text-field dense label="Name" v-model="client.name" hint="Enter patient's name" required></v-text-field>
                <v-text-field dense label="Date of Birth" mask="####" v-model="client.date_of_birth" required="required" type="number" min="1900" hint="Ener the year of birth"></v-text-field>
                <v-select dense label="Gender" :items="[{text: 'Female', value: 'Female'}, {text: 'Male', value: 'Male'}]" required="required" v-model="client.gender"></v-select>
                <v-text-field dense label="Phone" v-model="client.phone" hint="Enter phone number" placeholder="2547001234567"></v-text-field>
                <v-text-field dense label="Email" v-model="client.email" type="email" placeholder="user@gmial.com" hint="Enter email address"></v-text-field>
                <v-text-field dense label="Place of Residence" v-model="client.location" placeholder="Mombasa, Tudor, Kaa Chonjo, Creek Vn Heights, 3rd Floor" hint="Be as specific as possible"></v-text-field>
                <v-text-field dense label="Known Allergies" v-model="client.allergies" hint="Enter allergies, separated by a comma" placeholder="Penicilin, Anaesthesia"></v-text-field>
                <fieldset class="mb-2">
                  <legend>Next of Kin</legend>
                  <v-text-field dense label="Name" v-model="client.next_of_kin_name" hint="Enter the name of the next of kin"></v-text-field>
                  <v-text-field dense label="Phone" v-model="client.next_of_kin_phone" hint="Enter the phone of next of kin" placeholder="2547222225541"></v-text-field>
                </fieldset>
                <v-btn type="submit" small color="primary" class="pull-right">Save</v-btn><br>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import Layout from '@/Layouts/MainLayout'

  export default {
    name: 'CreateClient',
    metaInfo () {
      return {
        title: 'Add New Client',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    layout: Layout,
    data () {
      return {
        client: {},
      }
    },
    methods: {
      submit () {
        this.$inertia.post('/clients', this.client)
      }
    },
  }
</script>
